<div [class]="service.curThemeClass"><router-outlet></router-outlet><ng-snotify></ng-snotify></div>